// PACKAGES
import React, {useState, useEffect} from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import qs from "query-string";

// COMPONENTS
import ReactLoader from "react-loader-spinner";

// FILES
import translator, {translate_switch} from "../../../utils/translator";
import api from "../../../utils/api";
import {displayError} from "../../../utils/toastHelper";
import checkSettings from "../../../utils/checkSettings";
import "./NegotiationsPrint.scss";

const NegotiationsPrint = (props) => {
    // const {} = props;
    const [data, setData] = useState(null);
    const [order, setOrder] = useState(null);
    const [products, setProducts] = useState(null);
    const [rooms, setRooms] = useState(null);
    const location = useLocation();
    const { projectId } = qs.parse(location.search, { ignoreQueryPrefix: true });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const fetchedData = await api.post("/projects/fetch-negotiations", {projectId});
            setData(fetchedData);
            setOrder(fetchedData.order);
            setProducts(fetchedData.products);
            setRooms(fetchedData.rooms);
        } catch(error) {
			displayError(error, "Error fetching negotiations");
        }
    };

    const calculate = (item, key) => {
        let value = 0;
        switch (key) {
            case "discount_dollar":
                value = item.list - item.extended_net;
                break;
            case "discount_percentage":
                value = !parseFloat(item.list) ? 0.0 : (100.0 * (item.list - item.extended_net)) / item.list;
                break;
            case "margin_dollar":
                value = item.extended_net - item.standard_cost;
                break;
            case "margin_percentage":
                value = !parseFloat(item.extended_net) ? 0.0 : (100.0 * (item.extended_net - item.standard_cost)) / item.extended_net;
                break;
            case "standard_cost":
                value = item.standard_cost === "0.00" ? item.standard_cost : item.extended_net;
                break;
            default:
                value = item.extended_net;
                break;
        }
        return value.toFixed(2);
    };

    const total = !(data && order && products && rooms) ? 0 : order.reduce((total, orderRoom) => {
        const room = rooms[orderRoom.room];
        const roomTotal = orderRoom.products.reduce((roomTotal, prodId) => {
            const product = products[prodId];
            const quantity = room.products[prodId];
            const net = product.extended_net;
            return roomTotal + (quantity * net);
        }, 0);
        return total + roomTotal;
    }, 0)

    return data && order && products && rooms
        ? (
            <div className="print-container">
                <div>
                    <img src="https://dreamapi.emco.ca/images/logos/emco-large.png" alt="EMCO logo" />
                </div>
                <h1>Negotiations</h1>
                <table className="header-table">
                    <thead>
                        <tr>
                            <th>{translator("Negotiations", "customer_label")}</th>
                            <th>{translator("Misc", "project_title_label")}</th>
                            <th>{translator("Negotiations", "prepared_by_label")}</th>
                            <th>{translator("Negotiations", "warehouse_label")}</th>
                            <th>{translator("Negotiations", "ship_to_label")}</th>
                            <th>{translator("Negotiations", "quote_total_label")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{data.customer_name}</td>
                            <td>{data.project_title}</td>
                            <td>{data.consultant_name}</td>
                            <td>{data.warehouse}</td>
                            <td>{data.ship_to}</td>
                            <td>${total.toFixed(2)}</td>
                        </tr>
                    </tbody>
                </table>
                <table className="product-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>{translator("Negotiations", "sku_label")}</th>
                            {!checkSettings("hide_model_number") && <th>{translator("Negotiations", "model_label")}</th>}
                            <th>{translator("Negotiations", "qty_label")}</th>
                            <th>{translator("Negotiations", "desc_label")}</th>
                            <th>{translator("Negotiations", "list_label")}</th>
                            <th>{translator("Negotiations", "standard_label")}</th>
                            <th>{translator("Negotiations", "unit_net_label")}</th>
                            <th>{translator("Negotiations", "discount_dollar_label")}</th>
                            <th>{translator("Negotiations", "discount_percentage_label")}</th>
                            <th>{translator("Negotiations", "margin_dollar_label")}</th>
                            <th>{translator("Negotiations", "margin_percentage_label")}</th>
                            <th>{translator("Negotiations", "extended_net_label")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {order.map((orderedRoom) => {
                            const room = rooms[orderedRoom.room];
                            const roomProducts = orderedRoom.products.map((prodId) => ({
                                ...products[prodId],
                                id: prodId,
                                extended_net: parseFloat(products[prodId].extended_net),
                                list: parseFloat(products[prodId].list),
                                standard_cost: parseFloat(products[prodId].standard_cost),
                                unit_net: parseFloat(products[prodId].unit_net),
                            }));
                            return (
                                <>
                                    <tr className="new-product">
                                        <th rowSpan={roomProducts.length+1}>{room.title}</th>
                                    </tr>
                                    {roomProducts.map((product) => (
                                        <tr>
                                            <td>
                                                {product.stocked ? product.sku : "(NS)"}
                                                {/* {product.from_catalog && "(NW)"} */}
                                            </td>
                                            {!checkSettings("hide_model_number") && (<td>{product.model}</td>)}
                                            <td>{room.products[product.id]}</td>
                                            <td>
                                                {translate_switch({
                                                    en: product.en_description,
                                                    fr: product.fr_description
                                                })}
                                            </td>
                                            <td className="right-align">${parseFloat(product.list).toFixed(2)}</td>
                                            <td className="right-align">${parseFloat(product.standard_cost).toFixed(2)}</td>
                                            <td className="right-align">${parseFloat(product.unit_net).toFixed(2)}</td>
                                            <td className="right-align">${product.stocked ? calculate(product, "discount_dollar") : "0.00"}</td>
                                            <td className="right-align">{product.stocked ? calculate(product, "discount_percentage") : "0.00"}%</td>
                                            <td className="right-align">${product.stocked ? calculate(product, "margin_dollar") : "0.00"}</td>
                                            <td className="right-align">{product.stocked ? calculate(product, "margin_percentage") : "0.00"}%</td>
                                            <td className="right-align">${parseFloat(product.extended_net).toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        )
        : (
            <ReactLoader
                style={{ marginLeft: "8em" }}
                type="Oval"
                color="#00BFFF"
                height={50}
                width={50}
            />
        )
    ;
};

export default connect(() => ({}), () => ({}))(NegotiationsPrint);
